require('../../modules/es6.object.set-prototype-of');
module.exports = require('../../modules/_core').Object.setPrototypeOf;



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/library/fn/object/set-prototype-of.js
// module id = 231
// module chunks = 0